












import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    TermsEl: () => import('~/components/car/information/terms/TermsEl.vue'),
    TermsEn: () => import('~/components/car/information/terms/TermsEn.vue')
  },
  head() {
    return {
      title: this.$t('terms and conditions') as string
    }
  }
})
